import { j as s } from "../../../node_modules/react/jsx-runtime.js";
import { memo as T, useState as q, useRef as v, useCallback as d, useEffect as y } from "react";
import { clsx as A } from "../../../node_modules/clsx/dist/clsx.m.js";
import D from "../../../node_modules/lodash/startCase.js";
import { Typography as F } from "../Typography/Typography.js";
import r from "./Button.module.scss.js";
import f from "../Icon/Icon.js";
import G from "../Badge/Badge.js";
const H = ({
  className: b = "",
  children: h,
  label: l,
  testId: B,
  styles: R,
  iconOnly: t = !1,
  leadingIcon: m,
  trailingIcon: p,
  loading: e = !1,
  size: x = "medium",
  color: i = "primary",
  variant: n = "filled",
  disabled: $ = !1,
  onClick: u,
  // Add onClick prop
  pressed: a = !1,
  fullWidth: w = !1,
  type: z = "button",
  badge: j,
  formId: C,
  ...E
}) => {
  const [L, N] = q(a), o = v(null), c = j && n === "outlined" && !t && i === "neutral", P = d(
    (k) => {
      u && u(k), o.current && o.current.blur();
    },
    [u]
  ), S = d(() => e ? /* @__PURE__ */ s.jsx(
    f,
    {
      className: r.loader,
      name: "Loader"
    }
  ) : null, [e]);
  return y(() => {
    N(a);
  }, [a]), /* @__PURE__ */ s.jsxs(
    "button",
    {
      ref: o,
      className: A(
        r.button,
        r[`${i}${D(n)}`],
        r[x],
        b,
        {
          [r.iconOnly]: t,
          [r.loading]: e,
          [r.pressed]: L,
          "!w-full": !t && w
        }
      ),
      style: R,
      disabled: $,
      "data-testid": B,
      onClick: P,
      type: z,
      form: C,
      ...E,
      children: [
        !e && !t && m && /* @__PURE__ */ s.jsx(
          f,
          {
            name: m,
            size: "sm"
          }
        ),
        !e && !t && (l ? /* @__PURE__ */ s.jsx(
          F,
          {
            text: l,
            variant: x === "small" ? "interface/medium/s" : "interface/medium/sm"
          }
        ) : h),
        !e && !t && p && !c && /* @__PURE__ */ s.jsx(
          f,
          {
            name: p,
            size: "sm"
          }
        ),
        t && !e && m && /* @__PURE__ */ s.jsx(
          f,
          {
            name: m,
            size: "sm"
          }
        ),
        c && /* @__PURE__ */ s.jsx(G, { ...j }),
        S()
      ]
    }
  );
}, Y = T(H);
export {
  Y as default
};
//# sourceMappingURL=Button.js.map
